import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import VolunteerLayout from "layouts/volunteer";
import MemberLayout from "layouts/member";
import PublicLinkHub from "views/public/link-hub";
import SpiritualSurveyPage from "views/public/heartbeat-survey";
import PathwaysDemoPage from "views/public/pathways-demo";
import IntakePage from "views/public/shared/intake/IntakePage";
import IntakeTokenPage from "views/public/shared/intake/IntakeTokenPage";
import PulsePage from "views/public/shared/pulse/PulsePage";
import TeamCheckInPage from "views/public/team-checkin";

import "assets/css/Plugins.css";
import { useEffect } from "react";
import { initMixpanel, trackPageView } from "lib/mixpanel";
import { ThemeProvider } from "hooks/useTheme";
import { AuthProvider } from "hooks/useAuth";
import NotFound from "views/errors/404";
import { ErrorBoundary } from "views/errors/error-boundary";
import { Toaster } from "react-hot-toast";
import { ConfirmProvider } from "components/dialog/ConfirmProvider";

const App = () => {
  const location = useLocation();

  useEffect(() => { initMixpanel(); }, []);
  useEffect(() => { trackPageView(location.pathname); }, [location.pathname]);

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
        <Toaster position="top-center" reverseOrder={false} />
          <ConfirmProvider>
          <Routes>
            <Route path="volunteer/*" element={<VolunteerLayout />} />
            <Route path="member/*" element={<MemberLayout />} />
            <Route path="auth/*" element={<AuthLayout />} />
            <Route path="admin/*" element={<AdminLayout />} />
            <Route path="/" element={<Navigate to="/admin" replace />} />
            <Route path="/link-hub/:slug" element={<PublicLinkHub />} />
            <Route path="/connect/:slug" element={<PublicLinkHub />} />
            <Route path="/survey/qr/:qrToken" element={<SpiritualSurveyPage />} />
            <Route path="/survey/:token" element={<SpiritualSurveyPage />} />
            <Route path="/demo/pathways-survey" element={<PathwaysDemoPage />} />

            {/* Staff public routes */}
            <Route path="/staff-intake/t/:token" element={<IntakeTokenPage audience="staff" />} />
            <Route path="/staff-intake/:slug" element={<IntakePage audience="staff" />} />
            <Route path="/staff-pulse/:token" element={<PulsePage audience="staff" />} />
            <Route path="/team-checkin/:token" element={<TeamCheckInPage />} />

            {/* Volunteer public routes */}
            <Route path="/volunteer-intake/t/:token" element={<IntakeTokenPage audience="volunteer" />} />
            <Route path="/volunteer-intake/:slug" element={<IntakePage audience="volunteer" />} />
            <Route path="/volunteer-pulse/:token" element={<PulsePage audience="volunteer" />} />

            <Route path="*" element={<div className="flex min-h-screen bg-canvas text-fg"><NotFound showLogo /></div>} />
          </Routes>
          </ConfirmProvider>
        </AuthProvider>
                  
      </ThemeProvider>
    </ErrorBoundary>
  );
};


export default App;
